import React from 'react';

import { Flex } from '@sopranodesign/pulse-components';
import {
  MultiComposerMessageWrapper,
  MultiComposerGroupWrapper
} from '@sopranodesign/pulse-composer';
import { ConverseMessage, useBot } from '@sopranodesign/pulse-volt';

const ComposerWidget = () => {
  const { messages } = useBot();

  return (
    <Flex col fat="true" ySpace>
      <MultiComposerGroupWrapper>
        {messages.map((message) => (
          <MultiComposerMessageWrapper key={message.id} index={message.id} message={message}>
            <ConverseMessage
              message={message}
              handleButtonClick={() => { }}
              handleButtonLocationClick={() => { }}
              groupIndex={0}
              group={[message]}
              groups={[[messages]]}
            />
          </MultiComposerMessageWrapper>
        ))}
      </MultiComposerGroupWrapper>
    </Flex>
  );
};

export default ComposerWidget;
